import React, { useState } from "react";
import { Button, Grid, Typography, TextField } from "@mui/material";

const ModalNote = ({
  onClose,
  confirm,
  title,
  descriptionOne,
  copyButton,
  copyButtonClose,
}) => {
  const [note, setNote] = useState("");

  const getPreview = () => `Gentile Cliente,
la informiamo che sono richieste delle correzioni/integrazioni sul modulo ai fini anti-riciclaggio da lei inviato.
Nello specifico: ${note}
La invitiamo ad apportare le correzioni e a re-inviare il modulo apposito tramite la nostra procedura online CLICCANDO QUI.
Questo il nuovo codice OTP per accedere: [OTP]
Il link sarà valido fino al [DATA].
L'invio del modulo è condizione improrogabile per l'avvio/prosecuzione delle attività.
Per domande o chiarimenti può contattarci all'indirizzo amministrazione@lexia.it
Grazie.`;

  return (
    <Grid
      container
      item
      xs={11}
      md={7}
      sx={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#fff",
        maxHeight: "90vh",
        overflowY: "auto",
        width: { xs: "95%", sm: "80%" },
        borderRadius: "16px",
        outline: "none",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* ── Header ── */}
      <Grid
        item
        xs={12}
        style={{
          height: "60px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          borderBottom: "1px solid #c6c6c6",
          padding: "0 15px",
          gap: "10px",
          flexShrink: 0,
        }}
      >
        <div style={{ flexShrink: 0 }}>
          <div className="icon-modal-rejected" />
        </div>
        <Typography
          className="color-blue-dark"
          style={{ flex: 1, minWidth: 0, fontSize: "18px", fontWeight: 600 }}
        >
          {title}
        </Typography>
        <div style={{ flexShrink: 0 }}>
          <div onClick={onClose} className="icon-modal-close" />
        </div>
      </Grid>

      {/* ── Body ── */}
      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "20px 15px 0px",
        }}
      >
        {descriptionOne && (
          <Typography
            className="color-blue-dark"
            style={{ marginBottom: "20px", fontSize: "14px", color: "#666" }}
          >
            {descriptionOne}
          </Typography>
        )}

        <Typography
          className="color-blue-dark"
          style={{ marginBottom: "8px", fontSize: "14px", fontWeight: 600 }}
        >
          Motivo rigetto
        </Typography>
        <TextField
          placeholder="Inserisci"
          multiline
          minRows={3}
          maxRows={6}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          fullWidth
          variant="outlined"
          InputProps={{ style: { color: "#1b2838", fontSize: "14px" } }}
        />

        <>
          <Typography
            className="color-blue-dark"
            style={{
              marginTop: "24px",
              marginBottom: "8px",
              fontSize: "14px",
              fontWeight: 600,
            }}
          >
            Anteprima email
          </Typography>
          <Typography
            style={{
              padding: "14px 16px",
              backgroundColor: "#f5f5f5",
              borderRadius: "8px",
              whiteSpace: "pre-line",
              fontSize: "13px",
              color: "#444",
              lineHeight: 1.6,
              marginBottom: "8px",
            }}
          >
            {getPreview()}
          </Typography>
        </>
      </Grid>

      {/* ── Footer ── */}
      <Grid container item xs={12}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "20px",
          }}
        >
          <Button
            sx={{ width: "140px" }}
            className="button-bg-empty-small"
            onClick={onClose}
          >
            <Typography
              className="color-blue-dark"
              sx={{
                textTransform: "initial",
                fontSize: { xs: "16px", sm: "18px" },
                fontWeight: 500,
              }}
            >
              {copyButtonClose ?? "Chiudi"}
            </Typography>
          </Button>

          <Button
            className="button-bg-purple"
            sx={{ width: "140px" }}
            onClick={() => confirm(note)}
            disabled={note.trim() === ""}
          >
            <Typography
              className="color-light"
              sx={{
                textTransform: "initial",
                fontSize: { xs: "16px", sm: "18px" },
                fontWeight: 500,
              }}
            >
              {copyButton ?? "Invia"}
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ModalNote;
